export default __webpack_public_path__ + "static/es-039cad8d170e93fb93aa01995eee942a.svg";